// @givmo/fundraisers-module — every line the Donors tab shows (FCM-WEB49; plan §FC-17.3), as Jonathan
// ruled them with the mockups on 2026-10-22 09:08 PDT (D-FCM-55, "approved"),
// `scratchpad/2026-10-20-fcm-web49-donors-tab-mockups/`, copied from that set's copy list character for
// character. The line above the list is each class's own words, so it is host data
// (`FundraisersFlavor.donorsNote`, set in each console's mount), never a line here.
//
// The rows' facts are the server's (FCM-BE83's `OrganizerDonorRowOut`): a null `name` reads "Redacted"
// and a null `amount` "Amount not shown"; nothing here decides who is named or why.

export const DONORS_COPY = {
  /** The tab, and the title of its panel while no list serves: the plan's name (§FC-17.3), the
   *  module's own word for the people who gave (`p2p-campaign-page.tsx`'s leaderboard column). */
  tab: 'Donors',
  /** Column headers. "Donor", "Amount" and "Date" are the consoles' own (`crm-vocab.ts`, the employer
   *  module's approvals and give-history tables); "Message" is NEW, ruled. */
  donor: 'Donor',
  amount: 'Amount',
  date: 'Date',
  message: 'Message',
  /** RULED: D-FCM-39 (2026-10-17 13:26 PDT, "good"), Jonathan's own word in Q6. */
  redacted: 'Redacted',
  /** The plan's words (§FC-17.3: otherwise the row reads "Amount not shown"), ruled with the set. */
  amountNotShown: 'Amount not shown',
  /** Under an organization's own gift, as the portfolio puts "Campaign" under a campaign's name; the
   *  console's word (`@givmo/org-console`'s sidebar). */
  organization: 'Organization',
  /** The charity console's own empty title (`analytics-page.tsx`), in the module's "No … yet" pattern. */
  empty: 'No donations yet',
  /** NEW, ruled: the module's pattern ("Couldn’t load fundraisers", "Couldn’t load recipients"). */
  failed: 'Couldn’t load donations',
  /** The module's own failure body and action (`fundraisers-state.tsx`). */
  failedBody: 'Please try again.',
  retry: 'Try again',
  /** NEW, ruled: the tab's own address while no list serves (the detail carries no
   *  `organizer_tools.donor_list`, or the list answers its route miss); the supporter tab's pattern. */
  unavailable: 'The donor list isn’t available for this fundraiser here.',
  /** The module's paging (the portfolio's). */
  previous: 'Previous',
  page: (n: number) => `Page ${n}`,
  next: 'Next',
} as const;
